export const extractShopIdFromUrl = () => {
    const hostname = window.location.hostname;
    // Extract number from hostname (e.g., book-206.u2xx.com or book-57.u2xx.com)
    const match = hostname.match(/book-(\d+)/);
    let shopId = '206'; // Default value
    if (match && match[1]) {
        shopId = match[1];
    }
    // Store in localStorage
    localStorage.setItem('selectedShopId', shopId);
    return shopId;
};
export const getSelectedShopId = () => {
    return localStorage.getItem('selectedShopId') || '206';
};
